import React, { memo, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { bool, string } from 'prop-types';
import { destroy, submit } from 'redux-form';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';
import { actionCreators as accountActions } from 'redux/accountHandlers';
import { PENDING_FINE_AMOUNT_QUERY } from 'constants/reduxForms';

import PendingFineAmountQuery from './layout';
import styles from './styles.module.scss';
import { QUALITY } from './constants';

const PendingFineAmountQueryContainer = ({ dispatch, positiveCreditStatus, positiveCreditStatusLoading }) => {
  const [onOpenModal, setModalOpen] = useState(false);

  const handleOnSubmit = values =>
    dispatch(accountActions.getPositiveCreditStatus(values.clientNumber, QUALITY));

  const handleSubmitForm = () => dispatch(submit(PENDING_FINE_AMOUNT_QUERY));

  const handleModalOpen = useCallback(() => setModalOpen(true), [setModalOpen]);

  const handleModalClose = () => {
    setModalOpen(false);
    dispatch(accountActions.clearPositiveCreditStatus());
    dispatch(destroy(PENDING_FINE_AMOUNT_QUERY));
  };

  return (
    <div className={styles.container}>
      <UTLabel large black semibold>
        {message('Sidebar:consultFineQuality')}
      </UTLabel>
      <UTLabel black light small className={styles.content}>
        {appConfig.pendingFineAmountQuery.content}
      </UTLabel>

      <UTButton primary borderless onPress={handleModalOpen} className={styles.button}>
        {message('Commons:consult')}
      </UTButton>
      <PendingFineAmountQuery
        onOpenModal={onOpenModal}
        onCloseModal={handleModalClose}
        submitForm={handleSubmitForm}
        handleOnSubmit={handleOnSubmit}
        positiveCreditStatus={positiveCreditStatus}
        loading={positiveCreditStatusLoading}
      />
    </div>
  );
};

const mapStateToProps = store => ({
  positiveCreditStatus: store.account.positiveCreditStatus,
  positiveCreditStatusLoading: store.account.positiveCreditStatusLoading
});

PendingFineAmountQueryContainer.propTypes = {
  positiveCreditStatus: bool || string,
  positiveCreditStatusLoading: bool
};

export default connect(mapStateToProps)(memo(PendingFineAmountQueryContainer));
